// « Détail » of an appointment while it loads, as TaskDetailSkeleton for a
// task: grey shapes where its content lands, so nothing jumps when it arrives.
const GHOST = 'rounded bg-gray-200';

const SummaryGhost = ({ className = '' }) => (
  <span className={`flex items-center gap-3 p-3 ${className}`}>
    <span className="size-8 shrink-0 rounded-lg bg-gray-200" />
    <span className="flex min-w-0 flex-1 flex-col gap-1.5">
      <span className={`h-3 w-12 ${GHOST}`} />
      <span className={`h-3.5 w-4/5 ${GHOST}`} />
    </span>
  </span>
);

// Its summary (type, date, place, state), the person met, then the report.
const AppointmentDetailSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-4" aria-busy="true">
    <div className="grid grid-cols-2 rounded-xl border border-gray-200">
      <SummaryGhost className="border-r border-gray-200" />
      <SummaryGhost />
      <SummaryGhost className="border-r border-t border-gray-200" />
      <SummaryGhost className="border-t border-gray-200" />
    </div>
    <div className="flex items-center gap-3 rounded-xl border border-gray-200 p-3">
      <span className="size-10 shrink-0 rounded-full bg-gray-200" />
      <span className={`h-3.5 w-2/5 ${GHOST}`} />
      <span className="ml-auto h-8 w-20 shrink-0 rounded-lg bg-gray-200" />
    </div>
    <div className="flex flex-col gap-2">
      <span className={`h-3.5 w-24 ${GHOST}`} />
      <span className="h-28 rounded-lg bg-gray-200" />
    </div>
  </div>
);

export default AppointmentDetailSkeleton;
